const state = {
    totalPrice: 0,
};

const mutations = {
    setTotalPrice(state, price) {
        state.totalPrice = price;
      },
};

const actions = {
    updateTotalPrice({ commit }, price) {
        commit('setTotalPrice', price);
      },
};

const getters = {
    // ...
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};


// WEBPACK FOOTER //
// ./src/store/amount.js